import { Box, Button, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import { motion } from 'motion/react';
import { FrogBoxLogo } from '../frogbox-logo';

const MotionBox = motion.create(Box);
const MotionVStack = motion.create(VStack);

interface WelcomeStepProps {
  onGetStarted: () => void;
}

export const WelcomeStep: React.FC<WelcomeStepProps> = ({ onGetStarted }) => {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      minH="100vh"
      px={6}
      py={12}
      bg="white"
    >
      <MotionVStack
        gap={6}
        maxW="500px"
        textAlign="center"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* FrogBox Logo */}
        <MotionBox
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.5 }}
        >
          <FrogBoxLogo size="lg" />
        </MotionBox>

        {/* Quick Start Guide Title */}
        <MotionBox
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <Heading
            fontSize={{ base: '2xl', md: '3xl' }}
            fontWeight="black"
            color="green.500"
            textTransform="uppercase"
            letterSpacing="0.02em"
            lineHeight="1.1"
          >
            Quick Start Guide
          </Heading>
        </MotionBox>

        {/* Intro Text */}
        <MotionBox
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <VStack gap={3}>
            <Text
              fontSize={{ base: 'md', md: 'lg' }}
              color="gray.800"
              fontWeight="semibold"
            >
              It's game day and you're the legend setting up the FrogBox kit.
            </Text>
            <Text fontSize={{ base: 'sm', md: 'md' }} color="gray.600">
              This guide walks you through each step. Allow 2-5 minutes to
              complete all steps.
            </Text>
          </VStack>
        </MotionBox>

        {/* Get Started Button */}
        <MotionBox
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          pt={8}
        >
          <Button
            onClick={onGetStarted}
            size="lg"
            colorPalette="green"
            borderRadius="full"
            px={10}
            py={6}
            fontSize="md"
            fontWeight="semibold"
            _hover={{
              transform: 'translateY(-2px)',
            }}
            style={{ transition: 'all 0.2s' }}
          >
            GET STARTED
          </Button>
        </MotionBox>
      </MotionVStack>
    </Flex>
  );
};
